webpackJsonp([1],{

/***/ "1oY6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-simple-spinner/dist/vue-simple-spinner.js
var vue_simple_spinner = __webpack_require__("8kuj");
var vue_simple_spinner_default = /*#__PURE__*/__webpack_require__.n(vue_simple_spinner);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/event-bus.js






var bus = new vue_esm["default"]({
    name: 'EventBus',
    template: '<div></div>',
    data: function data() {
        return {
            seriesArrayMeta: [],
            rawData: {},
            deflactorIpc: {}
        };
    },

    watch: {
        seriesArrayMeta: function seriesArrayMeta(newArray) {
            this.$emit('seriesArrayMetaChanged', newArray);
        }
    },
    methods: {
        downloadData: function downloadData() {
            if (this.seriesArrayMeta.length === 0) {
                // If the array of series is empty, don't download new data. Instead emit an empty event.
                this.$emit('seriesarrayisempty');
            } else {
                var self = this;

                // Generar string para transformaciones y collapse al nivel de la serie
                var idString = lodash_default.a.map(self.seriesArrayMeta, function (seriesMeta) {
                    // If we're using a custom representation_mode, adjust it to one the API can understand
                    var repMode = void 0;
                    switch (seriesMeta.representation_mode.type) {
                        case 'index_100':
                            repMode = 'value';
                            break;
                        case 'value_with_deflactor':
                            repMode = 'value';
                            break;
                        default:
                            repMode = seriesMeta.representation_mode.type;
                            break;
                    }

                    return seriesMeta.serie_id + ':' + repMode;
                }).join(',');

                self.$emit('before-loading-data-from-api');
                axios_default.a.get('http://apis.datos.gob.ar/series/api/series/', {
                    params: {
                        ids: idString,
                        // collapse: 'quarter',
                        format: 'json',
                        limit: 1000
                    }
                }).then(function (response) {
                    var data = response.data;
                    if (false) {
                        window.data = data;
                    }
                    self.rawData = {
                        original_data: lodash_default.a.cloneDeep(data.data),
                        transformed_data: lodash_default.a.cloneDeep(data.data),
                        seriesFrequency: data.meta[0].frequency,
                        params: lodash_default.a.cloneDeep(data.params)
                    };
                    self.applySeriesTransformations();
                }).catch(function (error) {
                    console.log(error);
                    self.$toast('Error descargando datos de series, intente más tardde', {
                        className: 'et-alert',
                        horizontalPosition: 'center',
                        closable: 'true'
                    });
                }).then(function () {
                    self.$emit('finished-loading-data-from-api');
                });
            }
        },
        addSeriesMeta: function addSeriesMeta(newValue) {
            if (lodash_default.a.find(this.seriesArrayMeta, { serie_id: newValue.serie_id }) === undefined) {
                // check if this series already exists. If it does, don't add it
                // Add an internal id so we can reference this item in other parts
                var nextId = 1;
                if (this.seriesArrayMeta.length > 0) {
                    nextId = lodash_default.a.max(lodash_default.a.map(this.seriesArrayMeta, 'internal_series_id')) + 1;
                }
                newValue.internal_series_id = nextId;

                // Set the default values for this new series
                newValue.yAxisIndex = 0;
                newValue.representation_mode = {
                    type: 'value',
                    index100Date: null
                };
                newValue.dataTransform = {
                    type: 'none',
                    multiplyByValue: 1
                };
                newValue.serie_descripcion_transformada = newValue.serie_descripcion;
                newValue.serie_unidades_transformada = newValue.serie_unidades;

                // Push it into the main array
                this.seriesArrayMeta.push(newValue);

                // Download all data
                this.downloadData();
            } else {
                console.warn('Series was already included');
            }
        },
        removeSeriesMeta: function removeSeriesMeta(seriesId) {
            var index = lodash_default.a.findIndex(this.seriesArrayMeta, { internal_series_id: seriesId });
            this.seriesArrayMeta.splice(index, 1);
            // Download all data
            this.downloadData();
        },
        editSeriesMeta: function editSeriesMeta(seriesId, key, newValue, reDownloadData) {
            var index = lodash_default.a.findIndex(this.seriesArrayMeta, { internal_series_id: seriesId });
            var thisMeta = this.seriesArrayMeta[index];
            thisMeta[key] = newValue;
            vue_esm["default"].set(this.seriesArrayMeta, index, thisMeta);

            if (reDownloadData === true) {
                this.downloadData();
            } else {
                this.applySeriesTransformations();
            }

            return 0;
        },
        applySeriesTransformations: function applySeriesTransformations() {
            var self = this;
            lodash_default.a.map(self.seriesArrayMeta, 'internal_series_id').forEach(self.applySeriesTransformationsSingleSeries);
            this.updateMetaArrayWithTransformations();
            this.$emit('dataupdated', this.rawData, this.seriesArrayMeta);
        },
        applySeriesTransformationsSingleSeries: function applySeriesTransformationsSingleSeries(seriesId) {
            var self = this;
            var seriesIndex = lodash_default.a.findIndex(self.seriesArrayMeta, { internal_series_id: seriesId });
            var thisSeriesMeta = self.seriesArrayMeta[seriesIndex];
            var thisDataTransform = thisSeriesMeta.dataTransform;
            var thisRepresentationMode = thisSeriesMeta.representation_mode;

            var multiplyByValueIndex100 = void 0;
            if (thisRepresentationMode.type === 'index_100') {
                multiplyByValueIndex100 = self.getIndex100Factor(seriesId, thisRepresentationMode.index100Date);
            }

            for (var dateInd = 0; dateInd < self.rawData.transformed_data.length; dateInd++) {
                var oldValue = self.rawData.original_data[dateInd][seriesIndex + 1]; // the first element in the array for each day is the date itself, so we need to add 1
                var newValue = lodash_default.a.clone(oldValue);

                // First apply representation mode transformations
                if (thisRepresentationMode.type === 'index_100') {
                    newValue = newValue * multiplyByValueIndex100;
                } else if (thisRepresentationMode.type === 'value_with_deflactor') {
                    var today = self.rawData.original_data[dateInd][0];
                    var deflactor = self.getDeflactorForDate(today);
                    newValue = newValue / deflactor;
                }
                // Next apply custom transformations
                if (thisDataTransform.type === 'log') {
                    newValue = Math.log(newValue);
                } else if (thisDataTransform.type === 'none') {
                    // do nothing
                } else if (thisDataTransform.type === 'multiply_by') {
                    newValue = newValue * thisDataTransform.multiplyByValue;
                }
                // Check that value is good, otherwise set it to null
                if (!lodash_default.a.isFinite(newValue) || oldValue === null) {
                    newValue = null;
                }

                // Store the transformed value in the transformed_data array
                self.rawData.transformed_data[dateInd][seriesIndex + 1] = newValue;
            }
        },
        updateMetaArrayWithTransformations: function updateMetaArrayWithTransformations() {
            this.seriesArrayMeta = this.seriesArrayMeta.map(function (thisSeriesMeta, index) {
                var newSeriesMeta = lodash_default.a.cloneDeep(thisSeriesMeta);
                var thisDataTransform = thisSeriesMeta.dataTransform;
                var thisRepresentationMode = thisSeriesMeta.representation_mode;

                // First apply representation mode transformations
                if (thisRepresentationMode.type === 'index_100') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion + ' (Re-indexado: ' + thisRepresentationMode.index100Date + '=100)';
                    newSeriesMeta.serie_unidades_transformada = newSeriesMeta.serie_unidades + ' (' + thisRepresentationMode.index100Date + '=100)';
                } else if (thisRepresentationMode.type === 'change') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion + ' (Cambio)';
                } else if (thisRepresentationMode.type === 'percent_change') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion + ' (% Cambio)';
                } else if (thisRepresentationMode.type === 'percent_change_a_year_ago') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion + ' (% Cambio vs 1 año atrás)';
                } else if (thisRepresentationMode.type === 'value_with_deflactor') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion + ' (Deflactado Dic-2016=1)';
                } else {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion;
                    newSeriesMeta.serie_unidades_transformada = newSeriesMeta.serie_unidades;
                }

                if (thisDataTransform.type === 'log') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion_transformada + ' (Log)';
                    newSeriesMeta.serie_unidades_transformada = 'Log (' + newSeriesMeta.serie_unidades_transformada + ')';
                } else if (thisDataTransform.type === 'multiply_by') {
                    newSeriesMeta.serie_descripcion_transformada = newSeriesMeta.serie_descripcion_transformada + ' ( *' + Math.round(thisDataTransform.multiplyByValue * 10000) / 10000 + ')';
                } else {
                    // do nothing, no more changes needed
                }

                return newSeriesMeta;
            });
        },
        getPriceDeflactorSeries: function getPriceDeflactorSeries() {
            var self = this;
            axios_default.a.get(globalStore.metadataApiBaseUrl + 'deflactor/mensual').then(function (response) {
                var data = response.data.data;
                self.deflactorIpc = {
                    data: data,
                    dates_in_ms: lodash_default.a.map(data, function (thisDayData) {
                        return new Date(thisDayData[0]).getTime();
                    })
                };
            }).catch(function (error) {
                console.log(error);
                self.$toast('Error descargando serie IPC', {
                    className: 'et-alert',
                    horizontalPosition: 'center',
                    closable: 'true'
                });
            }).then(function () {
                self.$emit('price-deflactor-finished-loading');
            });
        },
        setAllMetaData: function setAllMetaData(newMeta) {
            this.seriesArrayMeta = newMeta;
            this.downloadData();
        },
        getAvailableDates: function getAvailableDates() {
            return lodash_default.a.map(this.rawData.original_data, lodash_default.a.first);
        },
        getIndex100Factor: function getIndex100Factor(seriesId, targetDateString) {
            var seriesIndex = lodash_default.a.findIndex(this.seriesArrayMeta, { internal_series_id: seriesId });
            var theData = lodash_default.a.find(this.rawData.original_data, function (x) {
                return x[0] === targetDateString;
            });
            if (theData !== undefined) {
                return 100 / theData[seriesIndex + 1];
            } else {
                console.warn('Could not find date to index by. Resetting units to value');
                this.seriesArrayMeta[seriesIndex].representation_mode.type = 'value';
                return 1;
            }
        },
        getDeflactorForDate: function getDeflactorForDate(dateString) {
            var dateInMs = new Date(dateString).getTime();
            var index = this.deflactorIpc.dates_in_ms.indexOf(dateInMs);
            if (index >= 0) {
                return this.deflactorIpc.data[index][1] / 100;
            } else {
                return null;
            }
        }
    }
});
/* harmony default export */ var event_bus = (bus);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
    name: 'app',
    components: {
        Spinner: vue_simple_spinner_default.a
    },
    data: function data() {
        return {
            loadingFromAPI: false
        };
    },

    mounted: function mounted() {
        var self = this;
        event_bus.$on('before-loading-data-from-api', function () {
            self.loadingFromAPI = true;
        });
        event_bus.$on('finished-loading-data-from-api', function () {
            self.loadingFromAPI = false;
        });

        // Also, when loading the page, load the IPC series to adjust series instantly
        event_bus.getPriceDeflactorSeries();
        // When we load the page, get all meta data from the query string and load the corresponding graphs
        if (self.$route.query.meta !== undefined) {
            event_bus.$on('price-deflactor-finished-loading', function () {
                event_bus.setAllMetaData(JSON.parse(self.$route.query.meta));
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c89896e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingFromAPI)?_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h4",attrs:{"id":"hide-screen"}},[_c('div',{staticClass:"spinner-container"},[_c('Spinner',{attrs:{"size":"massive","message":"Cargando..."}})],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("hajJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/fecha/fecha.js
var fecha = __webpack_require__("ldx2");
var fecha_default = /*#__PURE__*/__webpack_require__.n(fecha);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Chart.vue
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Chart = ({
    name: 'Chart',
    mounted: function mounted() {
        var self = this;

        event_bus.$on('seriesarrayisempty', function () {
            vue_esm["default"].set(self.options, 'series', []);
        });
        event_bus.$on('dataupdated', function (data, metaArray) {
            // Store data frequency //
            self.seriesFrequency = data.seriesFrequency;

            //  convert to series object
            var seriesArray = [];
            var dates = data.transformed_data.map(function (row) {
                var date = fecha_default.a.parse(row[0], 'YYYY-MM-DD');
                return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
            });
            metaArray.forEach(function (thisSeriesMeta, seriesIndex) {
                var thisSeries = {
                    name: thisSeriesMeta.serie_descripcion_transformada,
                    data: lodash_default.a.map(dates, function (date, dateIndex) {
                        return [date, data.transformed_data[dateIndex][seriesIndex + 1]];
                    }),
                    yAxis: thisSeriesMeta.yAxisIndex
                };
                seriesArray.push(thisSeries);
            });
            // console.log('Chart listened to new data, plotting it now. new seriesArray object')
            // console.log(seriesArray)

            // Set all options for Highcharts object
            vue_esm["default"].set(self.options, 'series', seriesArray);
            vue_esm["default"].set(self.options, 'xAxis', {
                type: 'datetime',
                labels: {
                    formatter: function formatter() {
                        var defaultText = this.axis.defaultLabelFormatter.call(this);
                        // console.log( defaultText)
                        if (self.seriesFrequency === 'quarter' && /[a-zA-z]/.test(defaultText)) {
                            var d = new Date(this.value);
                            return d.getFullYear() + ' T' + (Math.floor(d.getMonth() / 3) + 1);
                        } else {
                            return defaultText;
                        }
                    }
                },
                plotBands: [{
                    from: Date.UTC(1994, 12, 1),
                    to: Date.UTC(1995, 8, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }, {
                    from: Date.UTC(1998, 7, 1),
                    to: Date.UTC(2002, 4, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }, {
                    from: Date.UTC(2008, 5, 1),
                    to: Date.UTC(2009, 4, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }, {
                    from: Date.UTC(2011, 9, 1),
                    to: Date.UTC(2012, 4, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }, {
                    from: Date.UTC(2013, 8, 1),
                    to: Date.UTC(2014, 8, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }, {
                    from: Date.UTC(2015, 6, 1),
                    to: Date.UTC(2016, 10, 1),
                    color: 'rgba(10, 10, 10, .1)'
                }]
            });
            vue_esm["default"].set(self.options, 'tooltip', {
                split: false,
                formatter: function formatter() {
                    var pointFormatString = '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>';
                    pointFormatString = pointFormatString.replace('{point.color}', this.point.color);
                    pointFormatString = pointFormatString.replace('{series.name}', this.series.name);
                    pointFormatString = pointFormatString.replace('{point.y}', this.point.y);

                    var dateString = void 0;
                    var dateFormatString = '<span style="font-size: 10px">{point.key}</span><br/>';

                    var d = new Date(this.x);
                    if (self.seriesFrequency === 'quarter') {
                        dateString = d.getUTCFullYear() + ' T' + (Math.floor(d.getUTCMonth() / 3) + 1);
                    } else if (self.seriesFrequency === 'year') {
                        dateString = d.getUTCFullYear();
                    } else if (self.seriesFrequency === 'month') {
                        dateString = d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2);
                    } else {
                        dateString = d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (d.getUTCDate() + 1)).slice(-2);
                    }
                    dateFormatString = dateFormatString.replace('{point.key}', dateString);
                    return dateFormatString + pointFormatString;
                }
            });
            vue_esm["default"].set(self.options, 'yAxis', [{
                title: {
                    text: lodash_default.a.uniq(lodash_default.a.map(lodash_default.a.filter(metaArray, { yAxisIndex: 0 }), 'serie_unidades_transformada')).join(', ')
                },
                opposite: false,
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }]
            }, {
                title: {
                    text: lodash_default.a.uniq(lodash_default.a.map(lodash_default.a.filter(metaArray, { yAxisIndex: 1 }), 'serie_unidades_transformada')).join(', ')
                },
                opposite: true,
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }]
            }]);
        });
    },
    computed: {
        highcharts: function highcharts() {
            // return this.$refs.highcharts.chart
        }
    },
    data: function data() {
        return {
            initialLoadReady: true,
            seriesFrequency: null,
            options: {
                chart: {
                    height: 500
                },
                exporting: {
                    enabled: true

                },
                legend: {
                    enabled: true,
                    layout: 'vertical',
                    align: 'center',
                    verticalAlign: 'bottom',
                    borderWidth: 0
                },
                rangeSelector: {
                    allButtonsEnabled: true,
                    buttons: [{
                        type: 'year',
                        count: 5,
                        text: '5y'
                    }, {
                        type: 'year',
                        count: 10,
                        text: '10y'
                    }, {
                        type: 'all',
                        text: 'Max'
                    }]
                },
                yAxis: [{
                    title: {
                        text: ''
                    },
                    opposite: false,
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#808080'
                    }]
                }, {
                    title: {
                        text: ''
                    },
                    opposite: true,
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#808080'
                    }]
                }]

            }
        };
    },

    methods: {}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb6f78a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chart.vue
var Chart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('div',{staticClass:"alert alert-primary",attrs:{"role":"alert"}},[_vm._v("\n        Placeholder\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[(false)?_c('button',{on:{"click":_vm.updateChart}},[_vm._v("Test")]):_vm._e()]),_vm._v(" "),(_vm.initialLoadReady)?_c('highstock',{ref:"highcharts",attrs:{"options":_vm.options}}):_vm._e()],1)}
var Chart_staticRenderFns = []
var Chart_esExports = { render: Chart_render, staticRenderFns: Chart_staticRenderFns }
/* harmony default export */ var components_Chart = (Chart_esExports);
// CONCATENATED MODULE: ./src/components/Chart.vue
function Chart_injectStyle (ssrContext) {
  __webpack_require__("ngzC")
}
var Chart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chart___vue_template_functional__ = false
/* styles */
var Chart___vue_styles__ = Chart_injectStyle
/* scopeId */
var Chart___vue_scopeId__ = "data-v-cb6f78a0"
/* moduleIdentifier (server only) */
var Chart___vue_module_identifier__ = null
var Chart_Component = Chart_normalizeComponent(
  Chart,
  components_Chart,
  Chart___vue_template_functional__,
  Chart___vue_styles__,
  Chart___vue_scopeId__,
  Chart___vue_module_identifier__
)

/* harmony default export */ var src_components_Chart = (Chart_Component.exports);

// CONCATENATED MODULE: ./src/util.js
/*
//  convert csv to array
let dataArray = data.split('\n').map((x) => { return x.split(',') })
//  Remove header, and last row if needed
dataArray = dataArray.slice(1)
dataArray = _.filter(dataArray, (x) => { return x.length >= 2 })
//  convert strings to date and numbers
dataArray = dataArray.map((x) => { return [x[0]].concat(x.slice(1).map(parseFloat)) })

//  convert to series object
let seriesIndex = 1
let series = dataArray.map(function (row) {
    let date = fecha.parse(row[0], 'YYYY-MM-DD')
    return [Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())].concat(row.slice(seriesIndex, seriesIndex + 1))
})
console.log(series)
*/


var utilsMixin = {
    data: function data() {
        return {
            frequencyStringToNumeric: {
                'R/P1D': 1,
                'R/P1M': 30,
                'R/P3M': 90,
                'R/P6M': 180,
                'R/P1Y': 360
            }
        };
    },

    methods: {
        getReadableFrequency: function getReadableFrequency(freq) {
            var out = void 0;
            switch (freq) {
                case 'R/P1D':
                    out = 'Diario';
                    break;
                case 'R/P6M':
                    out = 'Semestral';
                    break;
                case 'R/P3M':
                    out = 'Trimestral';
                    break;
                case 'R/P1M':
                    out = 'Mensual';
                    break;
                case 'R/P1Y':
                    out = 'Anual';
                    break;
            }
            return out;
        },
        getReadableRange: function getReadableRange(freq, start, end) {
            var startDate = fecha_default.a.parse(start, 'YYYY-MM-DD HH:mm:ss');
            var endDate = fecha_default.a.parse(end, 'YYYY-MM-DD HH:mm:ss');
            var out = void 0;
            switch (freq) {
                case 'R/P1D':
                    out = fecha_default.a.format(startDate, 'YYYY-MM-DD') + ' - ' + fecha_default.a.format(endDate, 'YYYY-MM-DD');
                    break;
                case 'R/P6M':
                    out = startDate.getFullYear() + 'S' + (Math.floor(startDate.getMonth() / 6) + 1) + ' - ' + endDate.getFullYear() + 'S' + (Math.floor(endDate.getMonth() / 6) + 1);
                    break;
                case 'R/P3M':
                    out = startDate.getFullYear() + 'T' + (Math.floor(startDate.getMonth() / 3) + 1) + ' - ' + endDate.getFullYear() + 'T' + (Math.floor(endDate.getMonth() / 3) + 1);
                    break;
                case 'R/P1M':
                    out = fecha_default.a.format(startDate, 'YYYY-MM') + ' - ' + fecha_default.a.format(endDate, 'YYYY-MM');
                    break;
                case 'R/P1Y':
                    out = fecha_default.a.format(startDate, 'YYYY') + '-' + fecha_default.a.format(endDate, 'YYYY');
                    break;
            }
            return out;
        },
        getMinimumPossibleTimeframeCollapse: function getMinimumPossibleTimeframeCollapse(freqsArray) {}
    }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditSeries.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import fecha from 'fecha'

// import Vue from 'vue'


/* harmony default export */ var EditSeries = ({
    name: 'EditSeries',
    mixins: [utilsMixin],
    mounted: function mounted() {},
    data: function data() {
        return {
            currentEditedSeriesId: null,
            seriesYAxis: null,
            representation_mode: null,
            seriesDataTransform: null,
            initialLoadReady: true,
            seriesFrequency: null
        };
    },

    computed: {
        seriesArray: function seriesArray() {
            return event_bus.seriesArrayMeta;
        },
        minimumPossibleTimeframeCollapse: function minimumPossibleTimeframeCollapse() {
            var self = this;
            var freqNumber = lodash_default.a.map(self.seriesArray, function (x) {
                return self.frequencyStringToNumeric[x['indice_tiempo_frecuencia']];
            });
            return lodash_default.a.max(freqNumber);
        },
        availableDates: function availableDates() {
            return event_bus.getAvailableDates();
        }
    },
    methods: {
        updateChart: function updateChart() {
            this.initialLoadReady = !this.initialLoadReady;
        },
        removeSeries: function removeSeries(seriesId) {
            this.currentEditedSeriesId = null;
            event_bus.removeSeriesMeta(seriesId);
        },
        editSeries: function editSeries(series) {
            var seriesId = series.internal_series_id;
            if (this.currentEditedSeriesId === seriesId) {
                this.currentEditedSeriesId = null;
            } else {
                this.seriesYAxis = series.yAxisIndex;
                this.representation_mode = series.representation_mode;
                this.seriesDataTransform = series.dataTransform;

                this.currentEditedSeriesId = seriesId;
            }
        },
        updateYAxis: function updateYAxis() {
            event_bus.editSeriesMeta(this.currentEditedSeriesId, 'yAxisIndex', parseInt(this.seriesYAxis), false);
            this.updateDataTransform();
        },
        updateRepresentationMode: function updateRepresentationMode(event) {
            if (this.moreOptionsNeededStatus(event)) {
                // do nothing, more options needed
            } else {
                var reDownloadData = this.representation_mode.type !== 'index_100' && this.representation_mode.type !== 'value_with_deflactor';
                event_bus.editSeriesMeta(this.currentEditedSeriesId, 'representation_mode', this.representation_mode, reDownloadData);
            }
        },
        updateDataTransform: function updateDataTransform(event) {
            if (!lodash_default.a.isFinite(parseFloat(this.seriesDataTransform.multiplyByValue))) {
                this.seriesDataTransform.multiplyByValue = 1;
                return;
            }
            if (this.moreOptionsNeededStatus(event)) {
                // do nothing, more options needed
            } else {
                event_bus.editSeriesMeta(this.currentEditedSeriesId, 'dataTransform', this.seriesDataTransform, false);
            }
        },
        moreOptionsNeededStatus: function moreOptionsNeededStatus(event) {
            var out = false;
            if (event !== undefined) {
                if (event.target.id === 'select-representation-mode' && this.representation_mode.type === 'index_100') {
                    out = true;
                }
                if (event.target.id === 'select-data-transform' && this.seriesDataTransform.type === 'multiply_by') {
                    out = true;
                }
            }
            return out;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e46ebb9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditSeries.vue
var EditSeries_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-group"},_vm._l((_vm.seriesArray),function(series){return _c('a',{staticClass:"list-group-item list-group-item-action flex-column align-items-start",attrs:{"href":"#"}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('div',{staticClass:"h6 mb-1",on:{"click":function($event){$event.preventDefault();_vm.editSeries(series)}}},[_vm._v(_vm._s(series.serie_descripcion))]),_vm._v(" "),_c('div',{staticClass:"ml-2",staticStyle:{"flex-shrink":"0"}},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.editSeries(series)}}},[_c('i',{staticClass:"fa fa-pencil fa-lg"})]),_vm._v("  \n                    "),_c('span',{on:{"click":function($event){$event.preventDefault();_vm.removeSeries(series.internal_series_id)}}},[_c('i',{staticClass:"fa fa-trash fa-lg"})])])]),_vm._v(" "),(series.internal_series_id === _vm.currentEditedSeriesId)?_c('div',{staticClass:"mt-2"},[_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col-3",attrs:{"for":"inputYAxis"}},[_vm._v("Eje Y")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesYAxis),expression:"seriesYAxis"}],staticClass:"form-control",attrs:{"id":"inputYAxis"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seriesYAxis=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateYAxis]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Izquierdo")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Derecho")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col-3",attrs:{"for":"select-representation-mode"}},[_vm._v("Unidades")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.representation_mode.type),expression:"representation_mode.type"}],staticClass:"form-control",attrs:{"id":"select-representation-mode"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.representation_mode, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateRepresentationMode($event)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_c('option',{attrs:{"value":"value"}},[_vm._v("Valor")]),_vm._v(" "),_c('option',{attrs:{"value":"value_with_deflactor"}},[_vm._v("Valor adjustado por Inflación Verdadera")]),_vm._v(" "),_c('option',{attrs:{"value":"change"}},[_vm._v("Cambio")]),_vm._v(" "),_c('option',{attrs:{"value":"percent_change"}},[_vm._v("% de Cambio vs. período anterior")]),_vm._v(" "),_c('option',{attrs:{"value":"percent_change_a_year_ago"}},[_vm._v("% de Cambio vs. año anterior")]),_vm._v(" "),_c('option',{attrs:{"value":"index_100"}},[_vm._v("Índice base 100")])])]),_vm._v(" "),(_vm.representation_mode.type === 'index_100')?_c('div',{staticClass:"col-4"},[_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.representation_mode.index100Date),expression:"representation_mode.index100Date"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.representation_mode, "index100Date", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateRepresentationMode($event)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_vm._l((_vm.availableDates),function(date){return _c('option',{domProps:{"value":date}},[_vm._v(_vm._s(date))])})],2)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col-3",attrs:{"for":"select-data-transform"}},[_vm._v("Transformar")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesDataTransform.type),expression:"seriesDataTransform.type"}],staticClass:"form-control",attrs:{"id":"select-data-transform"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.seriesDataTransform, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateDataTransform($event)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("Ninguna")]),_vm._v(" "),_c('option',{attrs:{"value":"log"}},[_vm._v("Logaritmo")]),_vm._v(" "),_c('option',{attrs:{"value":"multiply_by"}},[_vm._v("Multiplicar por...")])])]),_vm._v(" "),(_vm.seriesDataTransform.type === 'multiply_by')?_c('div',{staticClass:"col-4 d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesDataTransform.multiplyByValue),expression:"seriesDataTransform.multiplyByValue"}],staticClass:"form-control",attrs:{"type":"search"},domProps:{"value":(_vm.seriesDataTransform.multiplyByValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.seriesDataTransform, "multiplyByValue", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.updateDataTransform($event)}}},[_c('i',{staticClass:"fa fa-arrow-right"})])])]):_vm._e()])])]):_vm._e()])}))])}
var EditSeries_staticRenderFns = []
var EditSeries_esExports = { render: EditSeries_render, staticRenderFns: EditSeries_staticRenderFns }
/* harmony default export */ var components_EditSeries = (EditSeries_esExports);
// CONCATENATED MODULE: ./src/components/EditSeries.vue
function EditSeries_injectStyle (ssrContext) {
  __webpack_require__("1oY6")
}
var EditSeries_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditSeries___vue_template_functional__ = false
/* styles */
var EditSeries___vue_styles__ = EditSeries_injectStyle
/* scopeId */
var EditSeries___vue_scopeId__ = "data-v-e46ebb9a"
/* moduleIdentifier (server only) */
var EditSeries___vue_module_identifier__ = null
var EditSeries_Component = EditSeries_normalizeComponent(
  EditSeries,
  components_EditSeries,
  EditSeries___vue_template_functional__,
  EditSeries___vue_styles__,
  EditSeries___vue_scopeId__,
  EditSeries___vue_module_identifier__
)

/* harmony default export */ var src_components_EditSeries = (EditSeries_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-paginate/dist/index.js
var dist = __webpack_require__("kBYy");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var HelloWorld = ({
    mounted: function mounted() {
        var self = this;
        // Whenever the meta is changed, push the new metadata into the query string.
        event_bus.$on('seriesArrayMetaChanged', function (newArray) {
            self.$router.push({ name: 'HelloWorld', query: { meta: stringify_default()(newArray) } });
        });

        this.searchQuery = '';
        this.debouncedSearch();
    },
    name: 'HelloWorld',
    components: {
        Chart: src_components_Chart,
        Paginate: dist_default.a,
        EditSeries: src_components_EditSeries
    },
    mixins: [utilsMixin],
    data: function data() {
        return {
            searchQuery: '',
            searchMinPeriodicity: 999,
            searchMinLastYear: 0,
            searchMaxFirstYear: 9999,
            searchDatasetTema: 'any',
            waitingSearchResults: false,
            searchResults: [],
            searchResultsCurrentPage: 1,
            searchResultsTotalPages: 1,
            searchResultsTotalResults: null,
            sidebarIsOpen: true,
            searchPossibleMaxYears: lodash_default.a.range(new Date().getFullYear(), 2000),
            searchPossibleMinYears: lodash_default.a.range(1881, new Date().getFullYear() - 1)
        };
    },

    methods: {
        doSearch: function doSearch() {
            var self = this;
            self.waitingSearchResults = true;
            axios_default.a.get(globalStore.metadataApiBaseUrl + 'query', {
                params: {
                    q: self.searchQuery,
                    min_periodicity: self.searchMinPeriodicity,
                    min_last_year: self.searchMinLastYear,
                    max_first_year: self.searchMaxFirstYear,
                    dataset_tema: self.searchDatasetTema,
                    page: self.searchResultsCurrentPage
                }
            }).then(function (response) {
                if (false) {
                    console.log('Response from query:');
                    console.log(response.data);
                }
                self.searchResults = response.data.data;
                self.searchResultsTotalPages = response.data.last_page;
                self.searchResultsTotalResults = response.data.total;
                if (response.data.status === 'bad query') {
                    self.searchResultsTotalResults = null;
                }
            }).catch(function (error) {
                console.log(error);
                self.$toast('Error en el buscador, intente nuevamente', {
                    className: 'et-alert',
                    horizontalPosition: 'center',
                    closable: 'true'
                });
            }).then(function () {
                self.waitingSearchResults = false;
            });
        },
        debouncedSearch: lodash_default.a.debounce(function (e) {
            // When typing a search query, reset the number of results and results page to the initial one
            this.searchResults = [];
            this.searchResultsCurrentPage = 1;
            this.doSearch();
        }, 500),
        addLine: function addLine(searchResult) {
            event_bus.addSeriesMeta(searchResult);
        },
        toggleSidebarMenu: function toggleSidebarMenu() {
            this.sidebarIsOpen = !this.sidebarIsOpen;
        },
        closeSidebarMenu: function closeSidebarMenu() {
            this.sidebarIsOpen = false;
        },
        goToSearchResultsPage: function goToSearchResultsPage(page) {
            this.searchResultsCurrentPage = page;
            this.doSearch();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3753ed58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"height":"100%"}},[_c('nav',{staticClass:"navbar navbar-light bg-faded"},[_c('div',[_c('i',{staticClass:"fa fa-bars fa-2x",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.toggleSidebarMenu($event)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeSidebarMenu),expression:"closeSidebarMenu"}],class:[_vm.sidebarIsOpen ? 'sidebar-menu-open' : 'sidebar-menu-closed'],attrs:{"id":"setup-panel"}},[_c('tabs',{attrs:{"options":{ useUrlFragment: false }}},[_c('tab',{attrs:{"name":"Agregar Serie"}},[_c('div',[_c('form',{staticClass:"pl-2 pr-2"},[_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"emae, ipc general, base monetaria, ..."},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.debouncedSearch]}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.doSearch($event)}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"form-group row ml-0 mb-2"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"select-dataset-tema"}},[_vm._v("Tema: ")]),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchDatasetTema),expression:"searchDatasetTema"}],staticClass:"form-control",attrs:{"id":"select-dataset-tema"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchDatasetTema=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.doSearch]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno....")]),_vm._v(" "),_c('option',{attrs:{"value":"any"}},[_vm._v("Cualquiera")]),_vm._v(" "),_c('option',{attrs:{"value":"Actividad"}},[_vm._v("Actividad")]),_vm._v(" "),_c('option',{attrs:{"value":"Precios"}},[_vm._v("Precios")]),_vm._v(" "),_c('option',{attrs:{"value":"Dinero y Bancos"}},[_vm._v("Dinero y Bancos")]),_vm._v(" "),_c('option',{attrs:{"value":"Sector Externo"}},[_vm._v("Sector Externo")]),_vm._v(" "),_c('option',{attrs:{"value":"Economía Internacional"}},[_vm._v("Economía Internacional")]),_vm._v(" "),_c('option',{attrs:{"value":"Finanzas Públicas"}},[_vm._v("Finanzas Públicas")]),_vm._v(" "),_c('option',{attrs:{"value":"Empleo e Ingresos"}},[_vm._v("Empleo e Ingresos")]),_vm._v(" "),_c('option',{attrs:{"value":"Mercados Financieros"}},[_vm._v("Mercados Financieros")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row ml-0 mb-2"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"select-periodicidad"}},[_vm._v("Periodicidad al menos: ")]),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMinPeriodicity),expression:"searchMinPeriodicity"}],staticClass:"form-control",attrs:{"id":"select-periodicidad"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchMinPeriodicity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.doSearch]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno....")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Diario")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("Mensual")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("Trimestral")]),_vm._v(" "),_c('option',{attrs:{"value":"360"}},[_vm._v("Anual")]),_vm._v(" "),_c('option',{attrs:{"value":"999"}},[_vm._v("Cualquiera")])])])]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("\n                            Último dato disponible:\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group row ml-0"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"select-first-year"}},[_vm._v("Desde: ")]),_vm._v(" "),_c('div',{staticClass:"ml-2 mr-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMaxFirstYear),expression:"searchMaxFirstYear"}],staticClass:"form-control",attrs:{"id":"select-first-year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchMaxFirstYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.doSearch]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_c('option',{attrs:{"value":"9999"}},[_vm._v("Cualquiera")]),_vm._v(" "),_vm._l((_vm.searchPossibleMinYears),function(year){return _c('option',{domProps:{"value":year}},[_vm._v("≤ "+_vm._s(year))])})],2)]),_vm._v(" "),_c('label',{staticClass:"col-form-label",attrs:{"for":"select-last-year"}},[_vm._v("Hasta: ")]),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMinLastYear),expression:"searchMinLastYear"}],staticClass:"form-control",attrs:{"id":"select-last-year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchMinLastYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.doSearch]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Elegir uno...")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Cualquiera")]),_vm._v(" "),_vm._l((_vm.searchPossibleMaxYears),function(year){return _c('option',{domProps:{"value":year}},[_vm._v("≥ "+_vm._s(year))])})],2)])])]),_vm._v(" "),_c('div',{attrs:{"id":"search-results"}},[(_vm.waitingSearchResults)?_c('div',[_vm._v("\n                            Buscando...\n                        ")]):_c('div',[(_vm.searchResultsTotalPages > 1)?_c('div',{attrs:{"id":"pagination"}},[_c('paginate',{ref:"paginate",attrs:{"page-count":_vm.searchResultsTotalPages,"click-handler":_vm.goToSearchResultsPage,"initial-page":_vm.searchResultsCurrentPage - 1,"prev-text":'Prev',"next-text":'Next',"page-range":2,"margin-pages":1,"container-class":'pagination',"page-class":'page-item',"page-link-class":'page-link',"prev-class":'page-item',"prev-link-class":'page-link',"next-class":'page-item',"next-link-class":'page-link'}})],1):_vm._e(),_vm._v(" "),(_vm.searchResultsTotalResults !== null)?_c('div',{staticClass:" small text-right"},[_vm._v("\n                                "+_vm._s(_vm.searchResultsTotalResults)+" series encontradas\n                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.searchResults),function(searchResult){return _c('a',{staticClass:"list-group-item list-group-item-action flex-column align-items-start",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.addLine(searchResult)}}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('div',{staticClass:"h6 mb-1"},[_vm._v(_vm._s(searchResult.serie_descripcion))])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(searchResult.serie_unidades))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                                        "+_vm._s(_vm.getReadableFrequency(searchResult.indice_tiempo_frecuencia))+".\n                                        "+_vm._s(_vm.getReadableRange(searchResult.indice_tiempo_frecuencia, searchResult.serie_indice_inicio, searchResult.serie_indice_final))+".\n                                        ("+_vm._s(searchResult.serie_id)+")\n                                    ")])])}))])])])]),_vm._v(" "),_c('tab',{attrs:{"name":"Editar Serie"}},[_c('EditSeries')],1),_vm._v(" "),_c('tab',{attrs:{"name":"Formato"}},[_vm._v("\n                En construcción\n            ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"d-flex",staticStyle:{"overflow-x":"hidden","height":"100%"}},[_c('div',{attrs:{"id":"the-chart"}},[_c('Chart')],1)]),_vm._v(" "),_vm._m(0)])}
var HelloWorld_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center",staticStyle:{"position":"relative","top":"-20px"}},[_vm._v("Meses de recesión sombreados en gris")]),_vm._v(" "),_c('h4',[_vm._v("Notas")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n                        Esta aplicación está basada en la excelente API de datos del Ministerio de Modernización.\n                        Las bases de datos originales se pueden encontrar "),_c('a',{attrs:{"href":"http://datos.gob.ar/dataset"}},[_vm._v("acá")]),_vm._v(", y\n                        las instrucciones para la API, "),_c('a',{attrs:{"href":"http://series-tiempo-ar-api.readthedocs.io/es/latest/"}},[_vm._v("acá")]),_vm._v(".\n                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                        La opción \"Valor ajustado por Inflación Verdadera\" deflacta cualquier serie con el índice mensual de 1943\n                        a hoy que hizo "),_c('a',{attrs:{"href":"http://www.inflacionverdadera.com/argentina/"}},[_vm._v("Inflación Verdadera")]),_vm._v(". Los datos\n                        hasta Diciembre de 2016 vienen de esa serie; la empalmé con el IPC General del INDEC a partir de esa fecha.\n                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                        El botoncito para bajar los datos viene en el próximo update.\n                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                        Preguntas, sugerencias, comentarios → "),_c('a',{attrs:{"href":"https://twitter.com/SoyYoConBonete_"}},[_vm._v("@SoyYoConBonete_")])]),_vm._v(" "),_c('li',[_vm._v("\n                        Github: "),_c('a',{attrs:{"href":"https://github.com/soy-yo-con-bonete/graficos-series-de-tiempo-ar"}},[_vm._v("soy-yo-con-bonete/graficos-series-de-tiempo-ar")])])])])])])}]
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var components_HelloWorld = (HelloWorld_esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function HelloWorld_injectStyle (ssrContext) {
  __webpack_require__("mnvy")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = "data-v-3753ed58"
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/',
        name: 'HelloWorld',
        component: src_components_HelloWorld
    }]
}));
// EXTERNAL MODULE: ./node_modules/vue-highcharts/src/index.js + 3 modules
var src = __webpack_require__("ajw3");

// EXTERNAL MODULE: ./node_modules/highcharts/modules/stock.js
var stock = __webpack_require__("WOHC");
var stock_default = /*#__PURE__*/__webpack_require__.n(stock);

// EXTERNAL MODULE: ./node_modules/highcharts/modules/exporting.js
var exporting = __webpack_require__("VVDx");
var exporting_default = /*#__PURE__*/__webpack_require__.n(exporting);

// EXTERNAL MODULE: ./node_modules/highcharts/highcharts.js
var highcharts = __webpack_require__("504h");
var highcharts_default = /*#__PURE__*/__webpack_require__.n(highcharts);

// EXTERNAL MODULE: ./node_modules/vue-tabs-component/dist/index.js
var vue_tabs_component_dist = __webpack_require__("2srq");
var vue_tabs_component_dist_default = /*#__PURE__*/__webpack_require__.n(vue_tabs_component_dist);

// EXTERNAL MODULE: ./node_modules/v-click-outside/dist/v-click-outside.min.js
var v_click_outside_min = __webpack_require__("T+v0");
var v_click_outside_min_default = /*#__PURE__*/__webpack_require__.n(v_click_outside_min);

// EXTERNAL MODULE: ./node_modules/vue-easy-toast/dist/vue-easy-toast.min.js
var vue_easy_toast_min = __webpack_require__("UV/M");
var vue_easy_toast_min_default = /*#__PURE__*/__webpack_require__.n(vue_easy_toast_min);

// CONCATENATED MODULE: ./src/main.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalStore", function() { return globalStore; });
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__webpack_require__("SSNS"); // Bootstrap
__webpack_require__("e0XP"); //   Icons

stock_default()(highcharts_default.a);
exporting_default()(highcharts_default.a);
vue_esm["default"].use(src["a" /* default */], { Highcharts: highcharts_default.a });

vue_esm["default"].use(v_click_outside_min_default.a);
vue_esm["default"].use(vue_tabs_component_dist_default.a);
vue_esm["default"].use(vue_easy_toast_min_default.a);

vue_esm["default"].config.productionTip = false;

/* Constantes */
var metadataApiBaseUrl = void 0;
if (true) {
    metadataApiBaseUrl = 'http://api-series-de-tiempo.tasacionya.com/';
} else {
    metadataApiBaseUrl = 'http://localhost:8000/';
}

var globalStore = new vue_esm["default"]({
    data: {
        metadataApiBaseUrl: metadataApiBaseUrl,
        analyticsId: 'UA-11247975-11'
    }
});

/* eslint-disable no-new */
new vue_esm["default"]({
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "SSNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hajJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mnvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ngzC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5eee3bafc196e70650c3.js